var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ZonalMap',{attrs:{"controlPanelProps":_vm.controlPanelProps,"colors":_vm.regionalColor,"fullWidth":true,"watermarkPosition":{ x: '2%', y: '2%', textXPercent: 85, textYPercent: 93 },"enableWatermark":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }